module.exports = __webpack_public_path__ + "static/media/startIconArchive.fe46fc04.svg";